import React, { FC } from 'react'
import styled from 'styled-components'

import { useTranslation } from 'helpers/hooks/useTranslation'
import Icon, { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { HeadingM } from 'uiComponents/atoms/Text/Headings'
import { ParagraphXS } from 'uiComponents/atoms/Text/Paragraphs'
import { bordersColor } from 'uiComponents/constants/colors'

const EmptyStreamContainer = styled.section`
  padding: 100px 0;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid ${bordersColor};
`

const Emoji = styled(Icon)`
  display: inline-block;
  margin-bottom: 10px;
`

const Heading = styled(HeadingM)`
  padding-bottom: 10px;
`

const EmptyStream: FC = () => {
  const { t } = useTranslation()

  return (
    <EmptyStreamContainer>
      <Emoji asset={IconName.IcAlertSmiley} size={IconSize.M} />
      <Heading>{t('Leider nichts gefunden...')}</Heading>
      <ParagraphXS>
        {t('Bearbeite Deine Filter um passende Suchergebnisse zu sehen')}
      </ParagraphXS>
    </EmptyStreamContainer>
  )
}

export default EmptyStream
